import Vue from "vue";
import Vuetify from "vuetify/lib";
import flaskIcon from "../components/flaskIcon.vue";

Vue.use(Vuetify);

export default new Vuetify({
  icons: { values: { flask: { component: flaskIcon } } }
});
